import React from "react";

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <section
      className="error-container"
      style={{
        textAlign: "center",
        padding: "20px",
        color: "#e74c3c",
      }}
    >
      <h3>เกิดข้อผิดพลาด</h3>
      <p>{message || "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง"}</p>
      {onRetry && (
        <button
          className="btn"
          onClick={onRetry}
          style={{
            marginTop: "10px",
            padding: "10px 20px",
            backgroundColor: "#3498db",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          ลองใหม่
        </button>
      )}
    </section>
  );
};

export default ErrorMessage;
